import { createRouter, createWebHistory } from 'vue-router'

export const routes = [
    {
        path: '/lxjsadmin/login',
        component: () => import('@/views/admin/Login.vue'),
        meta: {
            requiresAuth: false,
            noLayout: true
        }
    },
    {
        path: '/lxjsadmin',
        component: () => import('@/layouts/AdminLayout.vue'),
        meta: {
            requiresAuth: true
        },
        children: [
            // RBAC routes
            {
                path: 'users',
                component: () => import('@/views/admin/Users.vue'),
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: 'tutorials',
                component: () => import('@/views/admin/Tutorials.vue'),
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: 'tutorials/:id',
                component: () => import('@/views/admin/TutorialContent.vue'),
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: 'accounts',
                component: () => import('@/views/admin/AccountManagement.vue'),
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: 'keys',
                component: () => import('@/views/admin/KeyManagement.vue'),
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: 'partners',
                component: () => import('@/views/admin/Partners.vue'),
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: 'commission-ranking',
                component: () => import('@/views/admin/CommissionRanking.vue'),
                meta: {
                    requiresAuth: true
                }
            }
        ]
    }
]

export const history = createWebHistory('/')

export const guards = [
    async (to) => {
        if (to.meta.requiresAuth) {
            const { isLoggedIn } = await import('@/utils/auth')
            const response = await isLoggedIn()
            console.log(response.success);
            
            return response.success ? true : '/lxjsadmin/login'
        }
        return true
    }
]

const router = createRouter({ history, routes })
export default router
